import { render } from "./ViewButton.vue?vue&type=template&id=711d411b&scoped=true"
const script = {}

import "./ViewButton.vue?vue&type=style&index=0&id=711d411b&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711d411b"]])

export default __exports__